import { Navigate, useLocation } from 'react-router-dom';
import { IUser } from '@novakid/ts-types';
import { useContext } from 'react';

import { withAuthorization } from 'hocs';
import { UserContext } from 'contexts';

export const Main = withAuthorization(() => {
  const user = useContext(UserContext) as IUser;
  const { search } = useLocation();

  if (user.group === 'teachers') {
    return (
      <Navigate
        to={{ pathname: '/teacher', search }} 
        replace
      />
    );
  }
  
  return (
    <Navigate 
      to={{ pathname: '/select-account', search }}
      replace
    />
  );
});